import React, { useEffect, useState } from 'react';
import Header from '@components/Comman/Header';
import { Button, Pagination } from 'antd'; 
import { Divider, Space, Spin } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useDispatch } from 'react-redux';
import { getBusinessIReferAction } from '../../actions/refer';
import { useSelector } from 'react-redux';
import { formatAndCapitalizeString } from '@utils/comman';
import {
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  WhatsappIcon,
  XIcon,
  TwitterShareButton,
  LinkedinShareButton,
  InstapaperShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  EmailShareButton,
} from "react-share";
import SocialMediaCard from './SocialMediaCard';
import './index.css'
import SocialMediaPromotion from './SocialMediaHeader';
import { businessDetailsAction } from '../../actions/business';
import PageTitle from '@components/Comman/PageTitle';

interface DataType {
    key: string;
    firstName: string;
    lastName: string;
    email: string;
    businessCode: string;
    isRegistered: boolean;
}


const SocialMedia = () => {
  const [data, setData] = useState<DataType[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [pagination, setPagination] = useState({ totalItems: 0 });
  const userData = useSelector((state: any) => state?.Auth?.user?.user || state?.Auth?.user?.data);
  const businessDetails = useSelector((state: any) => state?.Business?.businessDetails);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const {isLoading} = useSelector((state: any) => state?.General);
 
    const columns: ColumnsType<DataType> = [
        {
            title: 'First Name',
            dataIndex: 'invite',
            key: 'invite',
            sorter: (a: any, b: any) => a.invite?.firstName?.localeCompare(b?.invite?.firstName),
            render: (text) => {
                return <>{text?.firstName}</>
            }
        },
        {
            title: 'Last Name',
            dataIndex: 'invite',
            key: 'invite',
            sorter: (a: any, b: any) => a.invite?.lastName.localeCompare(b?.invite?.lastName),
            render: (text) => {
                return <>{text?.lastName}</>
            },
        },
        {
            title: 'Email',
            dataIndex: 'user',
            key: 'user',
            sorter: (a: any, b: any) => a.user?.email?.localeCompare(b.user?.email),
            render: (text) => {
                return <>{text?.email}</>
            },
        },
        {
            title: 'Business Code',
            dataIndex: 'senderCode',
            key: 'senderCode',
            sorter: (a: any, b: any) => a?.senderCode?.localeCompare(b?.senderCode),
            render: (text) => <>{text}</>,
        },
        {
            title: 'Category',
            dataIndex: 'businessCategory',
            key: 'businessCategory',
            sorter: (a:any, b:any) => a.businessCategory.localeCompare(b.businessCategory),
            render: (text) => <>{formatAndCapitalizeString(text)}</>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record: any) => {
              return <Space size="middle">
                <div>
                  <FacebookShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <FacebookIcon size={24} round />
                  </FacebookShareButton>

                  <TwitterShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <XIcon size={24} round />
                  </TwitterShareButton>

                  <WhatsappShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <WhatsappIcon size={24} round />
                  </WhatsappShareButton>

                  <LinkedinShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <LinkedinIcon size={24} round />
                  </LinkedinShareButton>

                  <InstapaperShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <InstapaperIcon size={24} round />
                  </InstapaperShareButton>
                  
                  <TelegramShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <TelegramIcon size={24} round />
                  </TelegramShareButton>

                  <EmailShareButton url={record?.businessDetails?.url} title={record?.businessDetails?.businessName}>
                    <EmailIcon size={24} round />
                  </EmailShareButton>
                </div>
                </Space>
            },
        },
    ];

    useEffect(() => {
        const payload = { limit: pageSize, page };
        dispatch(
            getBusinessIReferAction(payload, (resp: any) => {
                if (resp?.status === 200) {
                    if (page === 1) {
                        setData(resp?.data); // initial load
                    } else {
                        setData((prev) => [...prev, ...resp?.data]); // append for "show more"
                    }
                    // setData(resp?.data);
                    setPagination(resp?.pagination);
                    setHasMore((resp?.pagination?.totalItems || 0) > page * pageSize);
                }
            })
        );
        dispatch( businessDetailsAction(payload, (resp: any) => {}) );

    }, [page, pageSize, dispatch]);

    const handleTableChange = (pagination: any) => {
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    let businessData = {
        ...businessDetails,
        business: {
            businessCode: userData?.businessCode,
            BusinessDetails: {
                businessName: userData?.businessDetails?.businessName,
                url: businessDetails?.url,
                image: businessDetails?.logoUrl
            }
        },

    }

    return (
        <div>
            <Header pagTitle="Social Media" />
            <div className="contentBody">
                {/* {isLoading ? <div className="spinner-container"><Spin /></div> :  */}
                <div className="bodycard">
                    {/* <div className="bodycardheading">Social Media</div> */}
                    <PageTitle pagTitle='' />
                    <SocialMediaPromotion />
                    <div className='social-business-title'>Click on below social media icons and share or scan QR to become referrer</div>
                    <div className='social-card'>
                        {userData?.roleId === 2 ? (
                            <SocialMediaCard showQr isPersonalBusiness={userData?.roleId !==3 ? true : false} topTitle="My Business Promotional Page" userData={userData} userRole={userData?.roleId} className="social-media-card" isRefer={true} data={businessData} key={0} />
                        ) : null}
                        {(userData?.roleId === 2 && data?.length) ? <Divider type="horizontal" style={{ border: '2px dashed #F47523', height: '45%' }} /> : '' }
                        {data?.map((item: any, index: number) => (
                            <SocialMediaCard showQr={userData?.roleId !==3 ? true : false} isPersonalBusiness={false} topTitle="Business I Refer Promotional Page" userData={userData} userRole={userData?.roleId} className="social-media-card" isRefer={false} data={item} key={index} />
                        ))}
                        {isLoading && <div className="spinner-container"><Spin /></div> }
                        {hasMore && (
                        <div style={{ textAlign: 'center', marginTop: 20 }}>
                            <Button
                            onClick={() => setPage((prev) => prev + 1)}
                            loading={isLoading}
                            className="btn btn-primary"
                            >
                            Show More
                            </Button>
                        </div>
                        )}
                    </div>
                    <div className="cardContentbody">
                        <div className="responsivetable">
                            {/* <Table
                                size='small'
                                columns={columns}
                                dataSource={data}
                                loading={loading}
                                pagination={{
                                    total: pagination?.totalItems,
                                    pageSize,
                                    current: page,
                                    showSizeChanger: true,
                                    pageSizeOptions: ['20', '50'],
                                }}
                                scroll={{ y: 264, x: 800 }}
                                onChange={handleTableChange}
                                rowKey='email'
                            /> */}
                            
                        </div>
                    </div>
                </div>
                {/* // } */}
            </div>
        </div>
    );
};

export default SocialMedia;

